import {
  KitIcon,
  NonReturnableIcon,
  RemanufacturedIcon
} from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ItemsInOrderTableDescriptorTag from '../ItemsInOrderTableDescriptorTag';
import ItemInOrderTableProp65Warning from '../ItemInOrderTableProp65Warning';

const ItemsInOrderTableAdditionalInfo = ({
  nonReturnablePartNumber,
  remanPartNumber,
  ssroBundle,
  prop65Warning
}) => {
  const [t] = useTranslation();

  return (
    <div>
      {nonReturnablePartNumber && (
        <ItemsInOrderTableDescriptorTag
          className="mb-2"
          iconClassName="u-fill--DarkGray my-0 me-2"
          icon={NonReturnableIcon}
          title={t('NON_RETURNABLE_PART')}
        />
      )}
      {remanPartNumber && (
        <ItemsInOrderTableDescriptorTag
          className="mb-2"
          iconClassName="u-fill--DarkGray my-0 me-2"
          icon={RemanufacturedIcon}
          title={t('REMANUFACTURED_PART')}
        />
      )}
      {ssroBundle?.map(({ selfServiceOptionName, selfServiceOptionId }) => (
        <ItemsInOrderTableDescriptorTag
          key={selfServiceOptionId}
          className="mb-2"
          iconClassName="u-fill--DarkGray my-0 me-2"
          icon={KitIcon}
          title={selfServiceOptionName}
        />
      ))}
      {prop65Warning && (
        <ItemInOrderTableProp65Warning prop65Warning={prop65Warning} />
      )}
    </div>
  );
};

ItemsInOrderTableAdditionalInfo.propTypes = {
  nonReturnablePartNumber: PropTypes.bool,
  remanPartNumber: PropTypes.bool,
  prop65Warning: PropTypes.string,
  ssroBundle: PropTypes.arrayOf(
    PropTypes.shape({
      selfServiceOptionId: PropTypes.string,
      selfServiceOptionName: PropTypes.string
    })
  )
};

export default ItemsInOrderTableAdditionalInfo;
